import { ApiGetLpInfo } from "@/api";
import { CCC_USDT_ADDRESS, CCC_FUSD_ADDRESS } from "@/config/env";
import { useQuery } from "@tanstack/react-query";
function getToken1Price(data: any): number {
  const { token0PoolBalance, token0Decimal, token1PoolBalance, token1Decimal } =
    data;

  const token0Amount = Number(token0PoolBalance) / 10 ** token0Decimal;
  const token1Amount = Number(token1PoolBalance) / 10 ** token1Decimal;

  if (token1Amount === 0 || token0Amount === 0) return 0;
  const token1Price = token0Amount / token1Amount;

  return token1Price;
}
const useFusdtPrice = () => {
  return useQuery({
    queryKey: ["fusdtPrice"],
    queryFn: async () => {
      const res = await ApiGetLpInfo(CCC_USDT_ADDRESS, CCC_FUSD_ADDRESS);
      const price = getToken1Price(res.data);
      return price;
      // return 0.05;
    },
    refetchInterval: 3000,
    enabled: !!CCC_USDT_ADDRESS && !!CCC_FUSD_ADDRESS,
  });
};

export default useFusdtPrice;
